import { Stack } from "@mui/material"
import { ESimpleQueryOperators, TSimpleQueryBuilder } from "./types"
import { useState } from "react"
import { Dropdown, Icon, Typography } from "cakemail-ui-components-v2"

export function SimpleQueryBuilder({ query, updateQuery, resourceName, dataChoice }: TSimpleQueryBuilder) {
    const mainOperator = Object.keys(query)?.[0] as ESimpleQueryOperators || ESimpleQueryOperators.or

    function recursiveQueryToUi(cQuery: object, lvl: number = 0) {
        return query?.[mainOperator]?.map((data: any) => {
            if (typeof data === "string") {

            } else if (Array.isArray(data)) {

            } else {

            }

            return <Stack className="operatorBlock">
                <Stack className="operatorBlockHead">
                    <Typography>{resourceName}</Typography>
                    <Dropdown options={[]} iconOnly />
                </Stack>
            </Stack>

        }) || []
    }

    function setMainOperator(op: ESimpleQueryOperators) {
        updateQuery({
            [op]: query[mainOperator]
        })
    }

    const queryToUi = recursiveQueryToUi(query)



    return <Stack className="conditionContainers" gap={4}>
        <Stack className="mainOperator" direction="row" justifyContent="flex-end" gap={2}>
            <Typography
                className={mainOperator === ESimpleQueryOperators.or ? "semiBold" : ""}
                onClick={() => { setMainOperator(ESimpleQueryOperators.or) }}
                color={mainOperator === ESimpleQueryOperators.or ? "primary.main" : "body1.main"}>
                Match Any
            </Typography>
            <Typography>/</Typography>
            <Typography
                className={mainOperator === ESimpleQueryOperators.and ? "semiBold" : ""}
                onClick={() => { setMainOperator(ESimpleQueryOperators.and) }}
                color={mainOperator === ESimpleQueryOperators.and ? "primary.main" : "body1.main"}>
                Match All
            </Typography>
        </Stack>

        {queryToUi}

    </Stack>
}